












































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { AjaxHelper } from '@/AjaxHelper';
import { IParentProfile, IStudentListAccountItem, IUserSession } from '@/interfaces';
import { Route, NavigationGuardNext } from 'vue-router';
import { getAxiosErrorMessage } from '@/utils';
import { UserGetters } from '@/Getters';

import List from '@/components/List.vue';
import ListItem from '@/components/ListItem.vue'; 
import Field from '@/components/Field.vue';
import TextField from '@/components/TextField.vue';
import Btn from '@/components/Btn.vue';
import BtnGroup from '@/components/BtnGroup.vue';
import StudentForm from '@/components/forms/StudentForm.vue';

import { date } from '@/filters';

@Component({
  name: 'account-form',
  components: { Field, TextField, Btn, List, ListItem, StudentForm, BtnGroup },
  filters: { date }
})
export default class AccountFormComponent extends Vue {
  @Prop() public value!: IParentProfile<IStudentListAccountItem> | null;

  public get user(): IUserSession | null { return this.$store.getters[UserGetters.getUser]; }
  public get account(): IParentProfile<IStudentListAccountItem> | null { return this.value; }

  public accountName = '';
  public saving = false;
  public deleting = false;

  public editableStudent: IStudentListAccountItem | null = null;
  public deletingStudent: IStudentListAccountItem | null = null;

  public editStudent(student: IStudentListAccountItem | null = null) {
    if (student === null) {
      student = { firstName: '', lastName: '', minecraftAccountId: 'test', minecraftAccountUserName: '', moodleUserName: '',  birthDate: null, courses: [] };
    } else {
      // Make a copy of this student so we can cancel if we want
      student = JSON.parse(JSON.stringify(student));
    }

    this.editableStudent = student;
  }

  public async saveStudent(newStudent: IStudentListAccountItem) {
    if (this.account !== null) {
      if (newStudent.studentId === undefined) {
        const student = await AjaxHelper.post<IStudentListAccountItem, IStudentListAccountItem>('/parentstudentmanagement', newStudent);
        this.account.students.push(student);
      } else {
        const student = await AjaxHelper.put<IStudentListAccountItem, IStudentListAccountItem>('/parentstudentmanagement', newStudent);
        const index = this.account.students.findIndex(x => x.studentId === student.studentId);
        if (index > -1) {
          this.account.students.splice(index, 1, student);
        }
      }

      setTimeout(() => this.editableStudent = null);
    }
  }

  public cancelStudentEdit() {
    this.editableStudent = null;
  }

  public async save() {
    if (this.account !== null) {
      try {
        this.saving = true;
        await AjaxHelper.put('/parentprofile', { firstName: this.account.firstName, lastName: this.account.lastName });
        this.$alert.success('Account successfully updated');
      } catch {
        this.$alert.danger('Server Error Occured');
      } finally {
        this.saving = false;
      }
    }
  }

  public async remove() {
    if (this.account !== null && confirm('Are you sure you want to delete account?')) {
      try {
        this.deleting = true;
        await AjaxHelper.delete('/parentprofile');
        this.$alert.success('Successfully removed account');
        if (await this.$store.dispatch('logout')) {
          this.$router.push('/');
        }
      } catch {
        this.$alert.danger('Server Error Occured');
      } finally {
        this.deleting = false;
      }
    }
  }

  public async removeStudent(student: IStudentListAccountItem) {
    if (this.account !== null && student.studentId !== undefined && confirm('Are you sure you want to remove?')) {
      try {
        const index = this.account.students.indexOf(student);
        if (index > -1) {
          this.deletingStudent = student;
          await AjaxHelper.delete(`/parentstudentmanagement?studentId=${student.studentId}`);
          this.account.students.splice(index, 1);
          this.$alert.success('Successfully Removed Student');
        }
      } catch (ex) {
        getAxiosErrorMessage(ex)
      } finally {
        this.deletingStudent = null;
      }
    }
  }
}
